import React, { Component } from 'react';
import AwardsComponent from './../components/awards';
// import * as api from '../api'
import parseDate from './../utils/parseDate';

export default class InnerNoAward extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false,
      awardsDom: null,
      curAwardInfo: {
        rateVal: '',
        nextornow: {}
      },
    }
  }

  componentWillMount() {
    let info = JSON.parse(sessionStorage.getItem('yqs_curGame_awardInfo'))
    let awardInfo = Object.assign({}, {
      rateVal: info.globalfight,
      nextornow: info.nextornow
    })
    this.setState({awardsDom: <AwardsComponent rateVal={info.globalfight}/>, curAwardInfo: awardInfo})
  }

  _handleRemindMe() {
    let info = JSON.parse(sessionStorage.getItem('yqs_curGame_awardInfo'))
    let beginTime = info.nextornow.beginTime
    let endTime = info.nextornow.endTime
    window.jr_bridge.then(function(res) {
      res.jsToGetResp(function(d) {
        console.log('callback_d',d)
        if (d.success === 0) {
          console.log('success')
        } else if (d.success === 1) {
          console.log('failed')
        }
      }, {
        "type": 36,
        "identifier": "摇钱树红包雨活动提醒：别忘了抢红包" + (+new Date()), //事件唯一标示 （必须）
        "title": "摇钱树红包雨活动提醒：别忘了抢红包", //事件名称（必须）
        "startDate": beginTime, //开始时间 标准的时间戳
        "endDate": endTime,   //结束时间 标准的时间戳
        "allDay": "",   //是否是全天 （bool，非必须，默认为NO）
        "backUrl": ""   //拓展url（非必须）
      })
    });
  }

  _handle2OhterActivities() {
    window.location.href = `https://m.jr.jd.com/vip/sign/html/index.html?id=1192&activityid=1158`
  }

  render() {
    let { nextornow } = this.state.curAwardInfo
    return (
      <div className='main_info'>
        {this.state.awardsDom}
        <div className='award_info'>
          <p className='tipStr'>哎呀，红包溜走啦</p>
          <p className='tipStr'>下一场继续来！</p>
        </div>
        {nextornow.nextTime !== 'noNext' ? <div className='nexttime'>下场预告 <span>{parseDate(nextornow.nextTime)}</span></div>: null}
        <div className='btn yellow' onClick={this._handleRemindMe.bind(this)} clstag="jr|keycount|yqsbhby|6">提醒我</div>
        <div className='btn blank' onClick={this._handle2OhterActivities.bind(this)} clstag="jr|keycount|yqsbhby|7">其它热门活动</div>
      </div>
    )
  }
}